import TabList from '@mui/lab/TabList';
import {Box, Stack, Typography, styled} from '@mui/material';

export const Root = styled(Stack)(({theme}) => ({
  maxWidth: 1128,
  width: 1128,
  minHeight: '100%',
  margin: '0 auto',
  backgroundColor: '#F5F6FA',
  padding: '24px 16px',
  [theme.breakpoints.up('md')]: {
    padding: '63px 33px 64px',
  },
}));

export const Header = styled(Stack)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '16px',
  marginBottom: '24px',
  flexWrap: 'wrap',
  padding: '0 72px',
});

export const HeaderTextBlock = styled(Stack)({
  gap: '16px',
  maxWidth: '580px',
});

export const Title = styled(Typography)<{isHistory?: boolean}>(({isHistory}) => ({
  fontWeight: 400,
  fontSize: isHistory ? '48px' : '40px',
  lineHeight: '110%',
  letterSpacing: '-0.05em',
  color: '#1A1A1A',
}));

export const Subtitle = styled(Typography)({
  maxWidth: '585px',
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '145%',
  letterSpacing: '-0.03em',
  color: '#4F4F4F',
});

export const BalanceCard = styled(Stack)(({theme}) => ({
  width: '100%',
  maxWidth: 264,
  minHeight: 119,
  padding: '15px 15px 12px',
  borderRadius: '6px',
  background: '#FFFFFF',
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.up('md')]: {
    width: 264,
  },
}));

export const BalanceCardTitle = styled(Typography)({
  marginBottom: '16px',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '24px',
  color: '#7E8285',
});

export const BalanceCardValue = styled(Typography)({
  fontWeight: 500,
  fontSize: '48px',
  lineHeight: '24px',
  color: '#0C0C0D',
});

export const RubleIcon = styled('img')({
  marginBottom: '-6px',
});

export const ContentContainer = styled(Stack)<{isHistory?: boolean; isReplenishment?: boolean}>(
  ({isHistory, isReplenishment}) => ({
    background: '#FFFFFF',
    borderRadius: '6px',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    margin: '0 auto',
    width: isHistory ? 1062 : 918,
    minHeight: isReplenishment ? 731 : 560,
  }),
);

export const TabsContainer = styled(Stack)(({theme}) => ({
  paddingTop: '20px',
  paddingBottom: '32px',
  paddingLeft: '16px',
  paddingRight: '16px',
  [theme.breakpoints.up('md')]: {
    paddingLeft: '27px',
    paddingRight: '27px',
  },
}));

export const StyledTabList = styled(TabList)({
  minHeight: 'auto',
  borderBottom: '0.5px solid #B9B9B9',
  '& .MuiTabs-flexContainer': {
    gap: 0,
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#0D99FF',
    height: '2px',
  },
  '& .MuiTab-root': {
    minWidth: '202px',
    maxWidth: '202px',
    minHeight: '48px',
    padding: '8px 10px',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '14px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: '#757575',
  },
  '& .MuiTab-root.Mui-selected': {
    color: '#0C0C0D',
  },
  '& .MuiTab-root:nth-of-type(3)': {
    minWidth: '162px',
    maxWidth: '162px',
  },
});

export const PanelsContainer = styled(Box)({
  '& .MuiTabPanel-root': {
    padding: 0,
    paddingTop: '26px',
    width: '100%',
  },
});
